import { Edit, SimpleForm, TextInput, SelectInput, useRecordContext } from 'react-admin';
import { Card, CardContent, Typography, Stack } from '@mui/material';

const tallInput = { '& .MuiInputBase-root': { minHeight: 48 } };

const UserTitle = () => {
    const record = useRecordContext();
    return <span>{record ? record.email : ''}</span>;
};

const UserDetails = () => {
    const record = useRecordContext();
    if (!record) return null;
    return (
        <Card sx={{ mb: 2, bgcolor: '#fafafa' }}>
            <CardContent>
                <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>Информация</Typography>
                <Stack spacing={0.5}>
                    <Typography variant="body2"><strong>ID:</strong> {record.id}</Typography>
                    <Typography variant="body2"><strong>Email:</strong> {record.email}</Typography>
                    <Typography variant="body2"><strong>Телефон:</strong> {record.phone || '—'}</Typography>
                </Stack>
            </CardContent>
        </Card>
    );
};

const UserEdit = () => (
    <Edit title={<UserTitle />}>
        <SimpleForm>
            <UserDetails />
            <TextInput source="firstName" label="Имя" fullWidth sx={tallInput} />
            <TextInput source="lastName" label="Фамилия" fullWidth sx={tallInput} />
            <SelectInput source="role" label="Роль" choices={[
                { id: 'User', name: 'Пользователь' },
                { id: 'Admin', name: 'Администратор' },
            ]} fullWidth sx={tallInput} />
        </SimpleForm>
    </Edit>
);

export default UserEdit;
